import Vue from 'vue'
import App from './App.vue'
import {BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import 'vue-step-progress/dist/main.css'
import JsonViewer from 'vue-json-viewer';
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';
import "@mdi/font/css/materialdesignicons.css";
import store from './store';
Vue.config.productionTip = false
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(JsonViewer)
new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
